import BlockSlider from "@components/BlockSlider"
import LinkBlock from "@components/LinkBlock"
import ProductBlockSimple from "@components/ProductBlockSimple"
import { getIn } from "@utils/index"
import * as R from "ramda"
import React from "react"

import { ContentfulContentBaseProps } from "../types"

interface ContentfulLinkSliderProps extends ContentfulContentBaseProps {}

const formatBlockLinks = R.map(({ image, link, text }) => ({
  image,
  link,
  title: text,
}))

const ContentfulLinkSlider: React.FC<ContentfulLinkSliderProps> = ({
  blockId,
  link,
  linkCards,
  linkText,
  linkTextShort,
  title,
  titleShort,
  useSmallCards,
}) => {
  const BlockComponent = useSmallCards ? ProductBlockSimple : LinkBlock
  return (
    <BlockSlider
      blockId={blockId}
      data={linkCards ? formatBlockLinks(linkCards) : []}
      renderBlock={(block) => (
        <BlockComponent
          image={getIn(block, "image.file.url")}
          link={block.link}
          title={block.title}
        />
      )}
      title={title}
      titleShort={titleShort}
      to={link}
      toText={linkText}
      toTextShort={linkTextShort}
      useSmallCards={useSmallCards}
    />
  )
}

export default ContentfulLinkSlider
